import GlobalModal from './global-modal';

export default GlobalModal;
